/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Trimester from './trimester';
import TrimesterDetail from './trimester-detail';
import TrimesterUpdate from './trimester-update';
import TrimesterDeleteDialog from './trimester-delete-dialog';

const TrimesterRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Trimester />} />
    <Route path="new" element={<TrimesterUpdate />} />
    <Route path=":id">
      <Route index element={<TrimesterDetail />} />
      <Route path="edit" element={<TrimesterUpdate />} />
      <Route path="delete" element={<TrimesterDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TrimesterRoutes;
